module.exports = __webpack_public_path__ + "img/calendar.9915ebe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/svgs/calendar.svg
// module id = 125
// module chunks = 1